export const fr = {
  common: {
    reserve: "Réservez un billard",
    popular: "Populaire",
    selection: "Sélection Johnny",
    ongoing: "En cours",
    upcoming: "À venir",
    expired: "Terminé",
    learnMore: "En savoir plus",
    viewMenu: "Voir le menu complet",
    viewAllEvents: "Tous les événements",
    bookTable: "Réserver une table",
    rights: "Tous droits réservés.",
    tagline: "Le meilleur endroit pour relaxer à Pierrefonds.",
    skipWait: "Évitez l'attente et réservez votre place pour une excellente soirée."
  },
  nav: {
    home: "Accueil",
    menu: "Menu",
    poolEvents: "Billard & Événements",
    gallery: "Galerie",
    about: "À Propos",
    contact: "Contact"
  },
  home: {
    hero: {
      welcome: "Bienvenue au",
      subtitle: "Le lieu de rendez-vous ultime à Pierrefonds pour du billard de qualité, des boissons fraîches et de la bonne nourriture.",
      explore: "Explorer le menu"
    },
    about: {
      since: "Depuis 1998",
      title: "Notre Histoire & Passion",
      text: "Le Bar Billard Johnny n'est pas seulement un endroit pour jouer au billard ; c'est un monument de Pierrefonds. Depuis plus de deux décennies, nous offrons un espace dynamique pour que la communauté se rassemble et relaxe."
    },
    menu: {
      title: "Sceptique ? Goûtez-y.",
      subtitle: "Explorez notre sélection de bouchées délicieuses et nos bières en fût rafraîchissantes."
    },
    events: {
      tag: "Quoi de neuf",
      title: "Événements à venir"
    },
    cta: {
      title: "Prêt pour une partie ?",
      text: "Rejoignez-nous ce soir pour la meilleure expérience de billard à Pierrefonds. Les tables sont disponibles selon le principe du premier arrivé, premier servi ou par réservation."
    }
  },
  about: {
    welcome: "Bienvenue au Bar Billard Johnny, la destination de choix pour le billard, l'excellente cuisine et les bons moments à Pierrefonds, Montréal.",
    title: "À Propos",
    missionTitle: "Notre Mission",
    missionText: "Offrir un espace dynamique et accueillant où la communauté peut se rassembler, se détendre et profiter d'un divertissement de premier choix.",
    p1: "Établi avec une passion pour le jeu et un amour pour notre communauté locale, Johnny est devenu bien plus qu'une simple salle de billard. Nous sommes un incontournable du quartier où les amis se rencontrent et les rivalités se règlent sur la table.",
    p2: "Nos installations disposent de tables professionnelles méticuleusement entretenues, garantissant une expérience exceptionnelle, que vous soyez un joueur occasionnel ou un compétiteur de ligue chevronné.",
    p3: "C'est pourquoi nous avons élaboré un menu rempli de classiques réconfortants et garni notre bar d'une large sélection de bières et de spiritueux. Notre équipe dévouée s'assure que votre verre n'est jamais vide.",
    footerBox: "Fièrement au service de Pierrefonds",
    footerText: "Nous sommes fiers de faire partie de la communauté dynamique de Montréal. Venez nous voir et découvrez pourquoi nous sommes le meilleur endroit en ville."
  },
  poolEvents: {
    title: "Événements & Tournois",
    subtitle: "Rejoignez la communauté. Des ligues professionnelles aux tournois décontractés du week-end.",
    hostTitle: "Organisez votre événement",
    hostText: "Vous planifiez un anniversaire ou un tournoi privé ? Johnny propose des réservations de tables et des forfaits de restauration pour les groupes.",
    features: [
      "Tables professionnelles réservées",
      "Personnel de service dédié",
      "Menus personnalisés",
      "Options de système de son privé"
    ],
    startsAt: "Commence à 19h00"
  },
  contact: {
    title: "Nous trouver",
    subtitle: "Prêt à jouer ? Nous sommes situés au cœur de Pierrefonds. Passez nous voir ou réservez votre table maintenant.",
    location: "Emplacement",
    hours: "Heures d'ouverture",
    cta: "Vous voulez réserver une table pour ce soir ?"
  },
  menu: {
    title: "Notre Menu",
    subtitle: "Faites le plein pour votre partie avec notre nourriture délicieuse et nos boissons rafraîchissantes.",
    ctaTitle: "Faim pour une partie ?",
    ctaText: "Prenez une table et commandez directement de votre place. Nous servons tard !"
  }
};